import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class PositionService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation POSITION_UPDATE(
          $id: String!
          $data: PositionInput!
        ) {
          positionUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.positionUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation POSITION_DESTROY($ids: [String!]!) {
          positionDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.positionDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation POSITION_CREATE($data: PositionInput!) {
          positionCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.positionCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation POSITION_IMPORT(
          $data: PositionInput!
          $importHash: String!
        ) {
          positionImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.positionImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query POSITION_FIND($id: String!) {
          positionFind(id: $id) {
            id
            name
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.positionFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query POSITION_LIST(
          $filter: PositionFilterInput
          $orderBy: PositionOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          positionList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id

              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.positionList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query POSITION_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          positionAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.positionAutocomplete;
  }
}
